import { useOutreachRoundResults } from '@/entities/outreach-candidate';
import { OutreachRoundResults } from './OutreachRoundResults';

/** 펼친 회차의 성과를 부른다 — 펼치기 전에는 이 컴포넌트가 서지 않아 조회도 없다. */
export function OutreachRoundResultsContainer({
  scenarioId,
  roundId,
}: {
  scenarioId: string;
  roundId: string;
}) {
  const query = useOutreachRoundResults(scenarioId, roundId);
  return (
    <OutreachRoundResults
      state={query.isPending ? 'loading' : query.isError ? 'error' : 'ready'}
      results={query.data}
    />
  );
}
